import React from 'react';
import { Box, Collapse, IconButton, SxProps, Theme } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

interface CollapsibleSettingsSectionProps {
  sectionId: string;
  title: React.ReactNode;
  expanded: boolean;
  onToggle: () => void;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

const CollapsibleSettingsSection: React.FC<CollapsibleSettingsSectionProps> = ({
  sectionId,
  title,
  expanded,
  onToggle,
  sx,
  children,
}) => (
  <Box sx={sx}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        mb: expanded ? 2 : 0,
      }}
      onClick={onToggle}
      role="button"
      tabIndex={0}
      aria-expanded={expanded}
      aria-controls={`account-settings-section-${sectionId}`}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
    >
      <IconButton
        size="small"
        aria-label={expanded ? 'Collapse section' : 'Expand section'}
        sx={{
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
        }}
      >
        <ExpandMoreIcon />
      </IconButton>
      <Box sx={{ flex: 1 }}>{title}</Box>
    </Box>
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <Box id={`account-settings-section-${sectionId}`}>{children}</Box>
    </Collapse>
  </Box>
);

export default CollapsibleSettingsSection;
